import * as Yup from "yup";

export const breakdownReportSchema = Yup.object({

    startDate: Yup.string().required("Please Select Start Date"),
    endDate: Yup.string().required("Please Select End Date"),
    


});